/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */


angular.module('access.DataTable')
    .factory('SortingService', [function() {
    function Sorting(sortingColumn, direction) {
        var
            ASC = 'asc',
            DESC = 'desc',
            column = sortingColumn,
            isAsc = direction !== DESC;

        this.setColumn = function (newColumn, defaultSortingDirection = ASC) {
            if (column == newColumn) {
                isAsc = !isAsc;
            } else {
                isAsc = defaultSortingDirection === ASC;
                column = newColumn;
            }
        };

        this.getDirection = function () {
            return this.isAsc() ? ASC : DESC;
        };

        this.getColumn = function () {
            return column;
        };

        this.getQueryParams = function () {
            var self = this;
            return {
                sort_by: self.getColumn(),
                sort_direction: self.getDirection()
            };
        };

        this.isAsc = function () {
            return isAsc;
        };
    }

    return {
        'new': function(columns, direction) {
            return new Sorting(columns, direction);
        }
    }
}]);
